var _react_refresh_temp_1;
import { string, z } from 'zod';
import { passwordValidator, userEmailValidator, } from '@lucidlink/dto/validation';
import { invitationDataSchema } from '#types/sdk/data-objects/invitation';
export const registerUserSchema = z
    .object({
    email: userEmailValidator,
    password: passwordValidator,
    repeatedPassword: string().optional(),
    invitationData: invitationDataSchema.optional(),
})
    // Exact sequence of refinement - first match the passwords, then make it required for the backend, just in case.
    // This is to simplify FE validation, as without repeatedPassword being optional the validator short circuits
    // before reaching any of the refines.
    .refine(({ password, repeatedPassword }) => password === repeatedPassword, {
    message: 'user.repeatedPassword.notMatch',
    path: ['repeatedPassword'],
})
    .refine(_react_refresh_temp_1 = ({ repeatedPassword }) => Boolean(repeatedPassword), {
    message: 'user.repeatedPassword.required',
    path: ['repeatedPassword'],
});
$RefreshReg$(_react_refresh_temp_1, "registerUserSchema$z\n    .object({\n        email: userEmailValidator,\n\n        password: passwordValidator,\n\n        repeatedPassword: string().optional(),\n\n        invitationData: invitationDataSchema.optional(),\n    })\n    // Exact sequence of refinement - first match the passwords, then make it required for the backend, just in case.\n    // This is to simplify FE validation, as without repeatedPassword being optional the validator short circuits\n    // before reaching any of the refines.\n    .refine(({ password, repeatedPassword }) => password === repeatedPassword, {\n        message: 'user.repeatedPassword.notMatch',\n        path: ['repeatedPassword'],\n    })\n    .refine");
